import { API_URL, numberWithCommas } from '../../constant';
import React, {useEffect, useState} from 'react';
import { useLocalStorage } from "../../useLocalStorage";
import "./Expedition.css";


let Expedition = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [expeditions, setExpeditions] = useState([]);
    
    function GetCost(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("WHCityID", props.whcityid);
        urlencoded.append("ShippingCityID", props.shippingcityid);
        urlencoded.append("totalweight", (props.totalweight) ? props.totalweight : 5);


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/ongkir/cost`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    const changeIsOpen = (val) => {
        props.changeIsOpen(val)
    }

    const ClickExpedition = (index, code, name, desc, price) =>{
        props.setExpedition(index, code, name, desc, price)
        changeIsOpen(false);
    }

    
    useEffect(async ()=>{
        let response = await GetCost()
        setExpeditions(response);
    },[]);
    return (
        <div className='expedition-container'>
            {/* <div className="expedition-flex" onClick={()=> ClickExpedition(props.index, "POS", "Kantor POS", '5000') }>
                <div className='expedition-name'>Kantor POS</div>
                <div className='expedition-price'>Rp. 5.000,-</div>
            </div>
            <div className="expedition-flex" onClick={()=> ClickExpedition(props.index, "JNE", "JNE", '5000') }>
                <div className='expedition-name'>JNE</div>
                <div className='expedition-price'>Rp. 5.000,-</div>
            </div> */}
            {
                (expeditions && expeditions.length > 0) ?
                    expeditions.map((value, index)=>{
                        return value.costs.map((val, idx)=>{
                            return(
                                <div className="expedition-flex" onClick={()=> ClickExpedition(props.index, value.code, value.name, val.description, val.cost[0].value) }>
                                    <div className='expedition-name'>
                                        <p>{value.name}</p>
                                        <p>{val.service} - {val.description}</p>
                                    </div>
                                    <div className='expedition-price'>Rp. {numberWithCommas(val.cost[0].value)}</div>
                                </div>
                            )
                        })
                    })
                : (<></>)
            }
        </div>
    );
}

export default Expedition;